import React from "react";
import { Link, Outlet, useLocation, useMatch } from "react-router-dom";
import { Icon } from "../Icon";
import { Footer, ScrollToTop, Wordmark } from "../Layout";
import { COMPANY } from "../data";
import { SEGMENT_BY_SLUG, contactLink } from "./content";
import "./landing.css";

/* =========================================================
   세그먼트 랜딩(/for/*) 전용 레이아웃
   본 사이트 메뉴 대신 짧은 헤더 + 언제나 보이는 [문의하기] 로 전환에 집중한다.
   - PC: 고정 헤더 오른쪽 버튼
   - 모바일: 화면 아래 고정 버튼 (엄지가 닿는 자리)
   푸터는 본 사이트와 같은 것을 써서 사업자 정보가 항상 보이게 한다.
   ========================================================= */
export default function LandingLayout() {
  const { pathname } = useLocation();
  const segMatch = useMatch("/for/:slug");
  const slug = segMatch && SEGMENT_BY_SLUG[segMatch.params.slug] ? segMatch.params.slug : "";
  const onContact = pathname.startsWith("/for/contact");
  const toContact = contactLink(slug);
  const ctaLabel = (slug && SEGMENT_BY_SLUG[slug].ctaLabel) || "아이디어 상담 문의하기";

  return (
    <div className={`App lp ${onContact ? "" : "lp--sticky"}`}>
      <ScrollToTop />
      <header className="lp-nav">
        <Link to="/" className="lp-nav__brand" aria-label={`${COMPANY.name} 홈`}>
          <Wordmark />
        </Link>
        <nav className="lp-nav__side">
          <Link to="/for" className="lp-nav__link">분야별 안내</Link>
          {!onContact && (
            <Link to={toContact} className="btn btn--primary lp-nav__cta">
              문의하기 <Icon.ArrowRight width="15" height="15" aria-hidden="true" focusable="false" />
            </Link>
          )}
        </nav>
      </header>

      <main>
        <Outlet />
      </main>

      <Footer />

      {!onContact && (
        <div className="lp-sticky">
          <Link to={toContact} className="btn btn--primary btn--block">
            {ctaLabel}
            <Icon.ArrowRight width="16" height="16" aria-hidden="true" focusable="false" />
          </Link>
        </div>
      )}
    </div>
  );
}
